import { ImLock, ImUsers } from "react-icons/im";
import { TbAirConditioning } from "react-icons/tb";
import { GrCar } from "react-icons/gr";
import { BsArrowUpRight } from "react-icons/bs";
import RButton from "../../components/RButton";
import { PiArrowUpRightBold } from "react-icons/pi";

export default function Card2({
  title,
  description,
  passengers,
  luggage,
  imageSrc,
}) {
  const ItemWrapper = ({ icon, text }) => {
    return (
      <div className="flex items-center text-sm space-x-2">
        <div className="flex items-center justify-center w-10 h-10 bg-[#F6F6F6] rounded-full">
          {icon}
        </div>
        <span className="text-xs color-[#181A1F]">Passengers: {text}</span>
      </div>
    );
  };
  return (
    <div className="w-[276px] mx-auto bg-white h-[340px]  border-gray-200  rounded-lg border-2 shadow-md p-4 transition duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl">
      <div>
        <div className="">
          <h2 className="text-sm font-normal color-[#181A1F]">{title}</h2>
          <p className="text-xs color-[#181A1F]">{description}</p>
        </div>
        <div className="flex items-center justify-center max-h-[103px] mt-2 overflow-hidden">
          <img alt={title} height="103" src={imageSrc} width="231" />
        </div>
        <div className="h-[150px] flex flex-col justify-between mt-2">
          <div className="flex justify-around">
            <ItemWrapper icon={<ImUsers />} text={passengers} />
            <ItemWrapper icon={<ImLock />} text={luggage} />
          </div>
          <div className="flex justify-around">
            <ItemWrapper
              icon={
                <img src="image/home/car_console.svg" className="w-6" alt="" />
              }
              text={passengers}
            />
            <ItemWrapper icon={<TbAirConditioning />} text={luggage} />
          </div>
          <div className="flex justify-between">
            <ItemWrapper icon={<GrCar />} text={passengers} />
            <div className="text-xs flex items-center space-x-2 w-[115px] h-[35px]">
              <RButton isradius={true}>
                <span
                  className="flex items-center gap-2 text-xs"
                  onClick={() => {
                    // setBookingModalVisible(true);
                    // console.log(props)
                  }}
                >
                  Book Now
                  <PiArrowUpRightBold className="text-xl" />
                </span>
              </RButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
